import { Component, Input } from '@angular/core';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';

@Component({
    selector: 'ins-appointment',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent {
    @Input() loaded: boolean;
    @Input() file_serial_number: number;
    @Input() appointment: ClaimAppointmentInterface;
}
